import BaseCommand from "@/models/api/commands/BaseCommand";
import { CONTRACTOR_TYPE_ENUM } from "@/static/contractorTypeEnum";

export class RemoveContractorCommand extends BaseCommand {
  CommandName = "RemoveContractor";
  Command: { Type: CONTRACTOR_TYPE_ENUM };
  constructor(sessionId: string, operationId: string, type: CONTRACTOR_TYPE_ENUM) {
    super(sessionId, operationId);
    this.Command = { Type: type };
  }
}
